module.exports = __webpack_public_path__ + "static/eis3-d80f36ffb0ba62637ff5a1b4288a74ec.jpg";